import React, { useContext, useReducer, useState, useEffect } from 'react';
import {
  Button,
  Checkbox,
  Footer,
  InfoBox,
  Input,
  Layout,
  MobileTabBar,
} from 'components';

import '../profile-general.less';
import './permission.less';

import { Form, message, Modal, Table, Tabs, Tooltip } from 'antd';

import RightChevronIcon from 'assests/icons/right-chevron.icon';
import DeleteIcon from 'assests/icons/delete.icon';
import UserWomen from 'assests/icons/user-women.icon';
import { DimensionsContext } from 'context/dimensions.context';
import ProfileMenu from '../profilemenu';
import { useSelector } from 'react-redux';
import {getMsisdnList,addMsisdn, removeMsisdn}  from 'services/msisdn.service';
import { customMessages, customValidators } from 'utils';

const Profile = () => {
  
  const auth = useSelector(state => state.auth);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isAuthorized, setIsAuth] = useState(true);
  const [valid, setValid] = useState(false);
  const [maxMsisdnCount, setMaxMsisdnCount] = useState(0);
  const [newPermissionModal, setNewPermissionModal] = useState(false);
  const [editPermissionModal, setEditPermissionModal] = useState(false);
  const { isTabletBig, isScreenLG } = useContext(DimensionsContext);

  const [form] = Form.useForm();

  function OnRemoveMsisdn(data) {
    removeMsisdn({ids :data })
      .then((result) => {
        fetchData();
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function OnAddMsisdn(data) {
    addMsisdn({ userOtpMsisdn :data })
      .then((result) => {  
        fetchData();
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  function fetchData() {
    getMsisdnList()
      .then((result) => {
        setArrayList(result.otpMsidnList);
        setMaxMsisdnCount(result.maxListSize);
      }).catch((response) => {
        setIsAuth(false);
        //message.error(customMessages.getMessage(response.responseCode));
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: '',
      dataIndex: 'check',
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setSelectedItems(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setSelectedItems([]);
                }
                forceUpdate();
              }}
            />
          ),
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setSelectedItems((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setSelectedItems(
                      selectedItems.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Gsm No',
      children: [
        {
          title: 'Tümünü Seç',
          dataIndex: 'msisdn',
        },
      ],
    },
    {
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {selectedItems.length > 0 ? (
                <div className="group-actions">
                  <button type="button"
                  onClick={() => {
                    OnRemoveMsisdn(selectedItems.map((item)=> item.msisdn));
                  }} >
                    <DeleteIcon />
                    Sil
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'createDate',
          render: (text,record) => (
            <>
              {/* <span>{text}</span> */}
              <div className="row-edit">
                <button
                  onClick={() => {
                    OnRemoveMsisdn([record.msisdn]);
                  }}
                  type="button"
                >
                  Sil <RightChevronIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];
  const mobileColumns = [
    {
      title: '',
      dataIndex: 'check',
      fixed: 'left',
      width: 60,
      children: [
        {
          title: () => (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  arrayList.map((item) => {
                    item.checked = true;
                    return item;
                  });
                  setSelectedItems(arrayList);
                } else {
                  arrayList.map((item) => {
                    item.checked = false;
                    return item;
                  });
                  setSelectedItems([]);
                }
                forceUpdate();
              }}
            />
          ),
          fixed: 'left',
          width: 60,
          dataIndex: 'check',
          render: (a, selectedRows, c) => (
            <>
              <Checkbox
                checked={selectedRows.checked}
                onChange={(e) => {
                  selectedRows.checked = e.target.checked;
                  if (selectedRows.checked === true) {
                    setSelectedItems((prevArray) => [
                      ...prevArray,
                      selectedRows,
                    ]);
                  } else {
                    setSelectedItems(
                      selectedItems.filter((e) => e !== selectedRows)
                    );
                  }
                  forceUpdate();
                }}
              />
            </>
          ),
        },
      ],
    },
    {
      title: 'Gsm No',
      fixed: 'left',
      width: 110,
      children: [
        {
          title: 'Tümünü Seç',
          fixed: 'left',
          width: 110,
          dataIndex: 'msisdn',
        },
      ],
    },
    {
      title: 'Oluşturulma',
      children: [
        {
          title: () => (
            <div className="table-group-actions">
              {selectedItems.length > 0 ? (
                <div className="group-actions">
                  <button type="button"
                  onClick={() => {
                    OnRemoveMsisdn(selectedItems.map((item)=> item.msisdn));
                  }} >
                    <DeleteIcon />
                    Sil
                  </button>
                </div>
              ) : null}
            </div>
          ),
          dataIndex: 'createDate',
          render: (text,record) => (
            <>
              {/* <span>{text}</span> */}
              <div className="row-edit">
                <button
                  onClick={() => {
                    OnRemoveMsisdn([record.msisdn]);
                  }}
                  type="button"
                >
                  Sil <RightChevronIcon />
                </button>
              </div>
            </>
          ),
        },
      ],
    },
  ];

  const onValuesChange = () => {
    setTimeout(() => {
      let inputs = form.getFieldsError();

      for (var i = 0; i < inputs.length; i++) {
        let formItemName = inputs[i]['name'][0];
        if (checkError(formItemName)) {
          setValid(true);
        } else {
          setValid(false);
          break;
        }
      }
    }, 10)
  }

  const checkError = fieldName => {
    if (form.isFieldTouched(fieldName) && form.getFieldError(fieldName).length === 0) {
      return true;
    }
  }


  const [arrayList, setArrayList] = useState([]);

  return (
    <Layout>
      <div className="profile-page profile-page--permission">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Profilim</h1>
          </div>
          <div className="content-wrapper">
          <ProfileMenu></ProfileMenu>
            <div className="profile-page__content">
              <h2 className="box__title">Yetki İşlemleri</h2>
              {isAuthorized === false && (
                <InfoBox
                  type="warning"
                  content={
                    <p>
                      Bu işlemi yapmaya yetkiliniz yok. Sadece kullanıcı numarası ile OTP giriş yapıldığında yetkilendirme yapılabilir.
                    </p>
                  }
                />
              )}
               {isAuthorized === true && (
              <div className="table-wrapper">
                <div className="new-permission">
                  <UserWomen />
                  <div>
                    <p className="info-text--big">
                      Seçtiğiniz ünvan için işlem yapabilmesini istediğiniz
                      çalışanlarınıza yetki tanımlayabilirsiniz.
                    </p>
                    <Button
                      type="primary"
                      shape="round"
                      onClick={() => {
                        setNewPermissionModal(true);
                      }}
                    >
                     Yetkili Ekle
                    </Button>
                  </div>
                
                </div>
                <InfoBox
                type="warning"
                content={
                  <p>
                    Bu ekrandan Mesaj Üssü’ne giriş yapmak için doğrulama kodu
                    gönderilebilecek numaraları düzenleyebilirsiniz. Bu işlemi
                    yalnızca Mesaj Üssü hesap sahibi gerçekleştirebilir. Listeye{' '}
                    <strong>en fazla {maxMsisdnCount} adet</strong> numara ekleyebilirsiniz.
                  </p>
                }
              />
                <Modal
                  title="Yetkili Kişi Ekle"
                  visible={newPermissionModal}
                  onCancel={() => setNewPermissionModal(false)}
                  footer={null}
                >
                  <Form 
                  form={form} 
                  name="msisdnForm" 
                  onValuesChange={onValuesChange}
                  onFinish={(values) => {
                    OnAddMsisdn(values.newMsisdn);
                    setNewPermissionModal(false);
                  }}>
                    <Form.Item
                      rules={[{ 
                        required: true ,
                        len: 10,
                        validator: customValidators.isMsisdn
                       }]}
                      name="newMsisdn"
                      messageVariables={{ label: 'Telefon Numarası' }}
                    >
                      <Input
                        type="tel"
                        name="newMsisdn"
                        maxLength={10}
                        label="Telefon Numarası"
                      />
                    </Form.Item>
                   
                    <div className="modal-action">
                      <Button
                        shape="round"
                        type="ghost"
                        onClick={() => setNewPermissionModal(false)}
                      >
                        Vazgeç
                      </Button>
                      <Button
                        key="confirm"
                        type="primary"
                        htmlType="submit"
                        disabled={ !valid }
                      >
                        Ekle 
                      </Button>
                    </div>
                  </Form>
                </Modal>
                  <Table
                    columns={isScreenLG ? mobileColumns : columns}
                    scroll={ isScreenLG ? { y: 610, x: 860 } : { y: 610 }}
                    dataSource={arrayList}
                    className="table--guide"
                    pagination={{ total: arrayList.length, position: ['bottomCenter'] }}
                  />
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default Profile;
